import { createSelector } from 'reselect';

import {
  FETCH_GLOBAL_ADMIN_STATS_DAT_SUCCESS,
  FETCH_GLOBAL_ADMIN_STATS_JSON_SUCCESS,
  GET_SUBSCRIPTION_INFO_SUCCESS,
  FETCH_BILLABLE_INFO_SUCCESS,
  FETCH_REPO_INFO_SUCCESS,
  FETCH_PRICE_INFO_SUCCESS,
} from '../../actions/globalAdminStats';

import {
  extractGlobalAdminStats
} from '../../utils/common';

import globalAdminStatistics from '../../utils/globalAdminStatistics';

const initialState = {
  globalAdminStatsDat: [],
  globalAdminStatsJson: {},
  softwareServices: [],
  templateServices: [],
  billableInfo: [],
  repoInfo: [],
  priceInfo: [],
};

export default function globalAdminStatsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_GLOBAL_ADMIN_STATS_DAT_SUCCESS:
      return {
        ...state,
        globalAdminStatsDat: extractGlobalAdminStats(action.payload.data),
    };
    case FETCH_GLOBAL_ADMIN_STATS_JSON_SUCCESS:
      return {
        ...state,
        globalAdminStatsJson: action.payload.data,
      };
    case GET_SUBSCRIPTION_INFO_SUCCESS: {
      const {
        softwareServices,
        templateServices,
        subscriptionChanges,
        lastSubscriptions,
        activeSubscribers,
      } = action.payload.data;
      return {
        ...state,
        softwareServices,
        templateServices,
        subscriptionChanges,
        lastSubscriptions,
        activeSubscribers,
      };
    }
    case FETCH_BILLABLE_INFO_SUCCESS: {
      return {
        ...state,
        billableInfo: action.payload.data,
      }
    }
    case FETCH_REPO_INFO_SUCCESS: {
      return {
        ...state,
        repoInfo: action.payload.data,
      }
    }
    case FETCH_PRICE_INFO_SUCCESS: {
      return {
        ...state,
        priceInfo: action.payload.data.clientPrices,
      }
    }
    default:
      return state;
  }
}

const getGlobalAdminStatsDat = state => state.globalAdminStats.globalAdminStatsDat;
const getGlobalAdminStatsJson = state => state.globalAdminStats.globalAdminStatsJson;
export const getSubscriptionServices = state => {
  const { softwareServices, templateServices } = state.globalAdminStats;
  return softwareServices.concat(templateServices);
};
const getSubscriptionChanges = state => state.globalAdminStats.subscriptionChanges;
const getLastSubscriptions = state => state.globalAdminStats.lastSubscriptions;
const getActiveSubscribers = state => state.globalAdminStats.activeSubscribers;

export const globalAdminStatisticsSelector = createSelector(
  [getGlobalAdminStatsDat, getGlobalAdminStatsJson],
  (globalAdminStatsDat, globalAdminStatsJson) =>
    globalAdminStatistics.getGlobalAdminStatistics(globalAdminStatsDat, globalAdminStatsJson)
);

export const globalAdminStatisticsClientDataSelector = createSelector(
    [getGlobalAdminStatsJson],
    (globalAdminStatsJson) =>
        globalAdminStatistics.getClientData(globalAdminStatsJson)
);

export const globalAdminStatisticsClientAdminsSelector = createSelector(
    [getGlobalAdminStatsJson],
    (globalAdminStatsJson) =>
        globalAdminStatistics.getClientAdmins(globalAdminStatsJson)
);

export const globalAdminStatisticsWithTimePeriodSelector = (clients, startDate, endDate) => createSelector(
    [getGlobalAdminStatsDat, getGlobalAdminStatsJson],
    (globalAdminStatsDat, globalAdminStatsJson) =>
        globalAdminStatistics.getGlobalAdminStatisticsWithTimePeriod(
            clients,
            globalAdminStatsDat,
            globalAdminStatsJson,
            startDate,
            endDate,
        )
);

export const globalResourcesSelector = createSelector(
  [getGlobalAdminStatsDat, getGlobalAdminStatsJson],
  (globalAdminStatsDat, globalAdminStatsJson) =>
    globalAdminStatistics.getGlobalResources(globalAdminStatsJson)
);

export const subscriptionInfoSelector = createSelector(
  [getSubscriptionChanges, getLastSubscriptions, getActiveSubscribers, getSubscriptionServices],
    (subscriptionChanges, lastSubscriptions, activeSubscribers, services) =>
        globalAdminStatistics.getSubscriptionInfo(subscriptionChanges, lastSubscriptions, activeSubscribers, services)
);
